export const FOCUS_OUTSIDE_EVENT_TYPE = 'focus-outside';

export function focusOutside(node: HTMLElement) {

    const focusoutListener = (event) => {
        if (!node.contains(event.relatedTarget)) {
            node.dispatchEvent(new CustomEvent(FOCUS_OUTSIDE_EVENT_TYPE))
        }
    }

    node.addEventListener('focusout', focusoutListener);
    return {
        destroy: () => node.removeEventListener('focusout', focusoutListener)
    }
}